import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgEntity = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  return (
    <svg
      width={10}
      height={13}
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.125 5.75H8.75c.305 0 .586.21.68.492a.753.753 0 0 1-.188.844l-6 5.25c-.281.21-.656.234-.937.023a.728.728 0 0 1-.258-.89L3.852 7.25H1.227a.713.713 0 0 1-.68-.469.753.753 0 0 1 .187-.843l6-5.25c.282-.211.657-.235.938-.024a.728.728 0 0 1 .258.89L6.125 5.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default SvgEntity;
